import type { BlackFridayBanner } from './BlackFridayBar';
import { mglGray } from '@/styles/designSystemColors';

export type LegacyBanner = {
  name: string;
  startDate: string;
  endDate: string;
  link: { url: string };
  color: { barColors: string; textColor: string; buttonBackground: string; textButtonColor: string; textBackground: string };
  emphasis?: { md: string; sm: string; xs: string };
  texts: { md: string; sm: string; xs: string; buttonText: string };
};

export const isBlackFriday = (banner: BlackFridayBanner | LegacyBanner): banner is BlackFridayBanner => 'variant' in banner && banner.variant === 'bf2026';

// Evento novo na agenda de quem clica, com o conteúdo inteiro (não copia o evento de ninguém).
const AGENDA_TITLE = encodeURIComponent('🤑 Live da Black Friday Canaltech 2026');
const AGENDA_BASE = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${AGENDA_TITLE}&ctz=America%2FSao_Paulo`;
const agendaUrl = (start: string, end: string, details: string) => `${AGENDA_BASE}&dates=${start}%2F${end}&details=${encodeURIComponent(details)}`;
const AGENDA_DETAILS =
  'Chegou o grande dia! Vem com a gente e acompanhe a cobertura ao vivo das melhores ofertas da Black Friday!!!<br>---<br><b>Acesse:</b> <a href="https://canaltech.com.br/live">https://canaltech.com.br/live</a>';
const AGENDA_LIVE_26 = agendaUrl('20261126T190000', '20261127T010000', `<b>🤑 Live: Virada Black Friday Canaltech</b><br>${AGENDA_DETAILS}`);
const AGENDA_LIVE_27 = agendaUrl('20261127T110000', '20261127T140000', `<b>🤑 Live: Black Friday Canaltech</b><br>${AGENDA_DETAILS}`);
const LIVE_URL = 'https://canaltech.com.br/live/';

export const bannerData: Array<BlackFridayBanner | LegacyBanner> = [
  {
    variant: 'bf2026',
    name: 'pre-bf2026',
    startDate: '2026-11-01T00:00:00-03:00',
    endDate: '2026-11-25T23:59:59-03:00',
    link: { url: AGENDA_LIVE_26 },
    badge: '26/11',
    texts: {
      md: 'Não perca a Black Friday 2026 do Canaltech!',
      sm: 'Não perca: live da Black Friday 2026',
      buttonText: 'Adicionar na agenda',
    },
  },
  {
    variant: 'bf2026',
    name: 'dia-bf2026',
    startDate: '2026-11-26T00:00:00-03:00',
    endDate: '2026-11-26T18:59:59-03:00',
    link: { url: AGENDA_LIVE_26 },
    badge: 'HOJE 19H',
    texts: {
      md: 'É hoje, não perca a nossa live da Black Friday!',
      sm: 'Hoje: live da Black Friday 2026',
      buttonText: 'Adicionar na agenda',
    },
  },
  {
    variant: 'bf2026',
    name: 'live-bf2026-primeira',
    startDate: '2026-11-26T19:00:00-03:00',
    endDate: '2026-11-27T02:00:59-03:00',
    link: { url: LIVE_URL },
    badge: 'AO VIVO',
    live: true,
    texts: {
      md: 'Estamos ao vivo: Black Friday Canaltech 2026!',
      sm: 'Ao vivo: Black Friday Canaltech 2026!',
      buttonText: 'Assistir à live',
    },
  },
  {
    variant: 'bf2026',
    name: 'dia-bf2026-entre-lives',
    startDate: '2026-11-27T02:01:00-03:00',
    endDate: '2026-11-27T10:59:59-03:00',
    link: { url: AGENDA_LIVE_27 },
    badge: 'HOJE 11H',
    texts: {
      md: 'É hoje, não perca a nossa live da Black Friday!',
      sm: 'Hoje: live da Black Friday 2026',
      buttonText: 'Adicionar na agenda',
    },
  },
  {
    variant: 'bf2026',
    name: 'live-bf2026-segunda',
    startDate: '2026-11-27T11:00:00-03:00',
    endDate: '2026-11-27T14:00:59-03:00',
    link: { url: LIVE_URL },
    badge: 'AO VIVO',
    live: true,
    texts: {
      md: 'Estamos ao vivo: Black Friday Canaltech 2026!',
      sm: 'Ao vivo: Black Friday Canaltech 2026!',
      buttonText: 'Assistir à live',
    },
  },
  {
    name: 'premio-ct-2023',
    startDate: '12/11/2023 12:45',
    endDate: '01/31/2024 23:59',
    link: {
      url: 'https://premio.canaltech.com.br/2023/?utm_source=canaltech&utm_medium=site-barra&utm_campaign=premio-canaltech',
    },
    color: {
      barColors: 'linear-gradient(224deg, #a92fd8, #20bcfe)',
      textColor: mglGray.mglGray50,
      buttonBackground: mglGray.mglGray900,
      textButtonColor: mglGray.mglGray50,
      textBackground: mglGray.mglGray50,
    },
    emphasis: {
      md: 'PRÊMIO CANALTECH: ',
      sm: 'PRÊMIO CANALTECH: Participe e Vote!',
      xs: 'Vote no Prêmio Canaltech!',
    },
    texts: {
      md: 'escolha os melhores da tecnologia de 2023!',
      sm: '',
      xs: '',
      buttonText: 'VOTAR AGORA!',
    },
  },
  {
    name: 'premio-ct-2023-resultado-sorteio',
    startDate: '02/19/2024 12:30',
    endDate: '03/01/2024 23:59',
    link: {
      url: 'https://premio.canaltech.com.br/2023/?utm_source=canaltech&utm_medium=site-barra&utm_campaign=sorteio-premio-canaltech',
    },
    color: {
      barColors: 'linear-gradient(224deg, #20bcfe, #a92fd8)',
      textColor: mglGray.mglGray50,
      buttonBackground: mglGray.mglGray900,
      textButtonColor: mglGray.mglGray50,
      textBackground: mglGray.mglGray50,
    },
    emphasis: {
      md: '',
      sm: 'PRÊMIO CT! Resultado do Sorteio',
      xs: 'Ver sorteados do Prêmio',
    },
    texts: {
      md: 'SAIU O RESULTADO DO SORTEIO DO PRÊMIO CANALTECH!',
      sm: '',
      xs: '',
      buttonText: 'CONFERIR',
    },
  },
];
